import Enums from "../../enums/enums";
const state = {
  notificationIsConnect: false,
  notificationReadyToUse: false,
  notificationIsAuthenticated: false,
  notificationList: [],
  notificationCount: 0,
  notificationListLoadingStatus: Enums.LoadingStatusType.None,
  notificationCountLoadingStatus: Enums.LoadingStatusType.None,
};

const getters = {
  GetNotificationIsConnect: (state) => {
    return state.notificationIsConnect;
  },
  GetNotificationReadyToUse: (state) => {
    return state.notificationReadyToUse;
  },
  GetNotificationList: (state) => {
    return state.notificationList;
  },
  GetNotificationCount: (state) => {
    return state.notificationCount;
  },
  GetNotificationListLoadingStatus: (state) => {
    return state.notificationListLoadingStatus;
  },
  GetNotificationCountLoadingStatus: (state) => {
    return state.notificationCountLoadingStatus;
  },
  GetNotificationIsAuthenticated: (state) => {
    return state.notificationIsAuthenticated;
  },
};

export { getters, state };
